import React from 'react';
import { useTranslation } from 'react-i18next';
import sanFranciscoImg from '../assets/locations/San Francisco.jpg';
import siliconValleyImg from '../assets/locations/Silicon_Valley.jpg';
import miamiImg from '../assets/locations/Miami.jpg';
import losAngelesImg from '../assets/locations/Los_Angeles.jpg';
import newYorkCityImg from '../assets/locations/New_York_City.jpg';
import fortWorthImg from '../assets/locations/DFW.jpg';
import sydneyImg from '../assets/locations/Sydney.jpg';

const OurLocationsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="our-locations-page">
      <section className="locations-section" style={{ paddingTop: '180px', marginTop: '60px' }}>
        <div className="container">
          <h1 style={{
            color: 'black',
            textAlign: 'left',
            position: 'relative',
            fontFamily: 'var(--font-primary)',
            fontSize: '2.8rem',
            fontWeight: 700,
            marginBottom: 'var(--spacing-lg)'
          }}>{t('locations_page_title')}
            <span style={{
              display: 'block',
              height: '3px',
              width: '100px',
              backgroundColor: 'gold',
              marginTop: '10px',
              marginBottom: '20px'
            }}></span>
          </h1>
          <p className="section-subtitle text-center" style={{ color: 'black' }}>{t('locations_page_subtitle')}</p>

          <div className="locations-grid">
            {/* San Francisco */}
            <div className="location-card">
              <div className="location-image">
                <img src={sanFranciscoImg} alt="San Francisco" />
              </div>
              <div className="location-content">
                <h2 className="location-title" style={{ color: 'black' }}>{t('location_sf_title')}</h2>
                <p className="location-description" style={{ color: 'black' }}>
                  {t('location_sf_description')}
                </p>
              </div>
            </div>

            {/* Silicon Valley */}
            <div className="location-card">
              <div className="location-image">
                <img src={siliconValleyImg} alt="Silicon Valley" />
              </div>
              <div className="location-content">
                <h2 className="location-title" style={{ color: 'black' }}>{t('location_sv_title')}</h2>
                <p className="location-description" style={{ color: 'black' }}>
                  {t('location_sv_description')}
                </p>
              </div>
            </div>

            {/* Miami */}
            <div className="location-card">
              <div className="location-image">
                <img src={miamiImg} alt="Miami" />
              </div>
              <div className="location-content">
                <h2 className="location-title" style={{ color: 'black' }}>{t('location_miami_title')}</h2>
                <p className="location-description" style={{ color: 'black' }}>
                  {t('location_miami_description')}
                </p>
              </div>
            </div>

            {/* Los Angeles */}
            <div className="location-card">
              <div className="location-image">
                <img src={losAngelesImg} alt="Los Angeles" />
              </div>
              <div className="location-content">
                <h2 className="location-title" style={{ color: 'black' }}>{t('location_la_title')}</h2>
                <p className="location-description" style={{ color: 'black' }}>
                  {t('location_la_description')}
                </p>
              </div>
            </div>

            {/* New York City */}
            <div className="location-card">
              <div className="location-image">
                <img src={newYorkCityImg} alt="New York City" />
              </div>
              <div className="location-content">
                <h2 className="location-title" style={{ color: 'black' }}>{t('location_nyc_title')}</h2>
                <p className="location-description" style={{ color: 'black' }}>
                  {t('location_nyc_description')}
                </p>
              </div>
            </div>

            {/* Fort Worth */}
            <div className="location-card">
              <div className="location-image">
                <img src={fortWorthImg} alt="Fort Worth" />
              </div>
              <div className="location-content">
                <h2 className="location-title" style={{ color: 'black' }}>{t('location_fw_title')}</h2>
                <p className="location-description" style={{ color: 'black' }}>
                  {t('location_fw_description')}
                </p>
              </div>
            </div>

            {/* Sydney, Australia */}
            <div className="location-card">
              <div className="location-image">
                <img src={sydneyImg} alt="Sydney, Australia" />
              </div>
              <div className="location-content">
                <h2 className="location-title" style={{ color: 'black' }}>{t('location_sydney_title')}</h2>
                <p className="location-description" style={{ color: 'black' }}>
                  {t('location_sydney_description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurLocationsPage; 